import {
  fork,
} from 'redux-saga/effects';

import updateAvailablePartsWatcher from './updateAvailablePartsWatcher';

export default function* root() {
  yield fork(updateAvailablePartsWatcher);
}
